
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import BgAvatarUploader from "@/components/bg-avatar-uploader/index.vue";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgAvatarUploader,
  },
})
export default class Factorie extends SupplierForm {
  form = {
    factoryInfo: {
      /** 大门 */
      gatePath: "",
      /** 版房 */
      versionRoomPath: "",
      /** 展厅 */
      showroomPath: "",
      /** 裁床 */
      cuttingBedPath: "",
      /** 办公区 */
      officeAreaPath: "",
      /** 生产车间 */
      workshopPath: "",
    },
  };
  maxSize = 1024 * 1024 * 4;
  get rules(): ElementUIFormRules {
    return this.getFieldsRules([
      "factoryInfo.gatePath",
      "factoryInfo.versionRoomPath",
      "factoryInfo.showroomPath",
      "factoryInfo.cuttingBedPath",
      "factoryInfo.officeAreaPath",
      "factoryInfo.workshopPath",
    ]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
  handleUploadChange(field: string) {
    const form = this.getFormRef();
    form.validateField(field);
  }
}
